import { endsText } from "@/components/AdDetails";
import { offerValue } from "@/components/listing/OfferPrice";

const ANIMALS = [
  { id: "cats", key: "cat", svc: "cat_services", icon: "🐱", count: "cat_count_pricing", table: "cat_count_note", ar: ["للقطط", "قط", "القطط"], en: ["for cats", "cat", "cats"] },
  { id: "dogs", key: "dog", svc: "dog_services", icon: "🐶", count: "dog_count_pricing", table: "dog_count_note", ar: ["للكلاب", "كلب", "الكلاب"], en: ["for dogs", "dog", "dogs"] },
  { id: "other", key: "other", svc: "other_animal_services", icon: "🐾", count: "other_count_pricing", table: "other_count_note", ar: ["للحيوانات الأخرى", "حيوان", "الحيوانات"], en: ["for other animals", "pet", "pets"] },
];

// Pet-care detail rows in the app's exact order; only filled fields. Arrays render as bullet lists.
export function petCareRows(meta, listing, lang) {
  const ar = lang !== "en";
  const T = (a, e) => (ar ? a : e);
  const aed = (n) => (ar ? `${n} درهم` : `AED ${n}`);
  const f = listing.fields || {};
  const tr = listing.tr?.[lang] || {};
  const offers = listing.dw_offers || {};
  const defs = Object.fromEntries((meta.subcat_fields.pet_care || []).map((d) => [d.key, d]));
  const L = (o) => (o ? (ar ? o.ar : o.en) : "");
  const types = String(f.pet_type || "").split(",").filter(Boolean);
  const rows = [];
  if (types.length) rows.push(["f_pet_type", T("نوع الخدمة", "Service type"), types.map((id) => L(defs.pet_type?.options?.find((o) => o.id === id)) || id), "multiselect"]);
  ANIMALS.filter((a) => types.includes(a.id)).forEach((a) => {
    const [forA, one] = ar ? a.ar : a.en;
    if (a.id === "other" && f.animal_name) rows.push(["f_animal_name", L(defs.animal_name), tr.animal_name || f.animal_name]);
    const v = f[a.svc];
    const def = defs[a.svc];
    if (v?.selected?.length && def) {
      const name = (id) => (id === "other" && v.other_text ? v.other_text : L(def.options?.find((o) => o.id === id)) || id);
      const all = v.mode === "all";
      const withEnds = (o) => ({ ...offerValue(o, aed, lang), until: endsText(o.until, lang) });
      const price = (id) => {
        const o = offers[`${a.key}_${id}`];
        return o ? withEnds(o) : aed(v.prices[id]);
      };
      const items = all ? v.selected.map((id) => [name(id), null]) : v.selected.filter((id) => v.prices?.[id]).map((id) => [name(id), price(id)]);
      const allOff = offers[`${a.key}_all`];
      const allPrice = (all || v.mode === "both") && v.all_price ? (allOff ? withEnds(allOff) : aed(v.all_price)) : null;
      if (items.length) rows.push([`f_${a.svc}`, `${a.icon} ${T(`الخدمات والأسعار ${forA} (درهم)`, `Services & prices ${forA} (AED)`)}`,
        { items, all: allPrice, allLabel: def.allLabel ? L(def.allLabel) : T("سعر جميع الخدمات", "Price of all services"), pkg: a.id }, "services"]);
    }
    if (f[a.count] && String(f[a.count]).split(",").includes("by_count")) {
      const t = f[a.table];
      const tdef = defs[a.table];
      const line = t && typeof t === "object" && t.min_count && t.price ? [`${L(tdef?.labels?.count)}: ${t.min_count} ${T("فأكثر", "or more")}`, aed(t.price)] : typeof t === "string" && t.trim() ? [t, null] : null;
      const sub = "";
      if (line) rows.push([`f_${a.table}`, T(`🌟 عرض حصري — السعر لأكثر من ${one}`, `🌟 Exclusive offer — price for more than one ${one}`), { sub, line }, "exclusive"]);
    }
  });
  if (f.service_areas) rows.push(["f_service_areas", T("المناطق التي يصلون إليها", "Areas they cover"), tr.service_areas || f.service_areas]);
  return rows;
}
